import { render } from "./job-invoice.vue?vue&type=template&id=4bf55af8"
import script from "./job-invoice.vue?vue&type=script&lang=js"
export * from "./job-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__